export const scrollToElementIdSmooth = (item) => {
  // console.log(document.getElementById(item));
  if (document.getElementById(item) !== null) {
    document.getElementById(item).scrollIntoView({ behavior: "smooth" });
  }
};
